import React from 'react';
import { CopyLinkProps } from './types';
import { Button, Tooltip } from '@vtbhome/juicyfront';
import { AllLink } from '@vtbhome/juicyfront/indexIcon';
import { Typography } from '@shared/ui/typography/typography';
import toast from 'react-hot-toast';
import { Toast } from '@shared/ui/toast/toast';

export const CopyLink: React.FC<CopyLinkProps> = ({ url, tooltipMessage, successMessage, errorMessage }) => {
    const handleClick = () => {
        navigator.clipboard.writeText(url).then(
            () => {
                toast.custom((t) => {
                    return (
                        <Toast
                            type='success'
                            title='Успешно!'
                            description={successMessage}
                            onClose={() => {
                                toast.remove(t.id);
                            }}
                        />
                    );
                });
            },
            () => {
                toast.custom((t) => {
                    return (
                        <Toast
                            type='error'
                            title='Ошибка!'
                            description={errorMessage}
                            onClose={() => {
                                toast.remove(t.id);
                            }}
                        />
                    );
                });
            }
        );
    };

    return (
        <Tooltip>
            <Button size='s' buttonType='secondary' startAdornment={<AllLink />} onClick={handleClick} />
            <Typography size='body2_short'>{tooltipMessage}</Typography>
        </Tooltip>
    );
};
